import { z } from 'zod';

/** RoleCreate — POST /api/eraf/roles */
export const roleCreateSchema = z.object({
  code: z
    .string()
    .min(1, '역할 코드를 입력해주세요')
    .max(64, '역할 코드는 64자 이하여야 합니다')
    .regex(/^ROLE_[A-Z_]+$/, "역할 코드는 'ROLE_' 로 시작하고 대문자와 밑줄만 포함해야 합니다"),
  nameKo: z
    .string()
    .min(1, '한글 이름을 입력해주세요')
    .max(128, '한글 이름은 128자 이하여야 합니다'),
  nameEn: z
    .string()
    .max(128, '영문 이름은 128자 이하여야 합니다')
    .optional(),
  description: z
    .string()
    .max(512, '설명은 512자 이하여야 합니다')
    .optional(),
  priority: z
    .number({ invalid_type_error: '우선순위를 입력해주세요' })
    .int('정수로 입력해주세요')
    .min(1, '우선순위는 1 이상이어야 합니다')
    .max(999, '우선순위는 999 이하여야 합니다')
    .optional(),
});

export type RoleCreateFormValues = z.infer<typeof roleCreateSchema>;

/** RoleUpdate — PATCH /api/eraf/roles/{id} */
export const roleUpdateSchema = z.object({
  nameKo: z
    .string()
    .min(1, '한글 이름을 입력해주세요')
    .max(128, '한글 이름은 128자 이하여야 합니다')
    .optional(),
  nameEn: z
    .string()
    .max(128, '영문 이름은 128자 이하여야 합니다')
    .optional(),
  description: z
    .string()
    .max(512, '설명은 512자 이하여야 합니다')
    .optional(),
  priority: z
    .number({ invalid_type_error: '우선순위를 입력해주세요' })
    .int('정수로 입력해주세요')
    .min(1, '우선순위는 1 이상이어야 합니다')
    .max(999, '우선순위는 999 이하여야 합니다')
    .optional(),
});

export type RoleUpdateFormValues = z.infer<typeof roleUpdateSchema>;

/** MatrixUpdate — PATCH /api/eraf/roles/{id}/permissions */
export const matrixUpdateSchema = z.object({
  permissionCodes: z
    .array(z.string().min(1))
    .max(100, '권한은 최대 100개까지 선택할 수 있습니다'),
});

export type MatrixUpdateFormValues = z.infer<typeof matrixUpdateSchema>;
